module.exports = __webpack_public_path__ + "img/zhanli1.7f4093a5.jpg";